module.exports = __webpack_public_path__ + "images/bug_dark_green_large_4b31254d405a8c9d3f3621ab6365c985.png";